__turbopack_context__.v({
  "cta-btn": "CTA-module-scss-module__x4p7KW__cta-btn",
  "cta-btn_type__primary": "CTA-module-scss-module__x4p7KW__cta-btn_type__primary",
  "cta-btn_type__primary_inverse": "CTA-module-scss-module__x4p7KW__cta-btn_type__primary_inverse",
  "cta-btn_type__secondary": "CTA-module-scss-module__x4p7KW__cta-btn_type__secondary",
  "cta-btn_type__secondary_inverse": "CTA-module-scss-module__x4p7KW__cta-btn_type__secondary_inverse",
});
